
import PropTypes from 'prop-types';

import _ from 'lodash';


const FeaturedSpaces = (props) => {

    const { title, isHome, errorMessage, selectedCity, isLanding } = props;        

    let message =
        `The server encountered an error and could not complete your request. 
         If the problem persists, please contact support and mention this error message: ${errorMessage}
         and explain what happened before the error occurred.`;    

    return (
        <div className={`container-root container-root-maxWidthLg ${ isHome ? 'featured-spaces-home-container' : 'featured-spaces-container' }`}>
            <div className='featured-spaces-building-row'>
                <div>
                    <h4>
                        {title} in {_.get(selectedCity, 'name')}
                    </h4>
                </div>
            </div>
            <div className='main-grid-container main-grid-spacing-xs-4 featured-spaces-building-grid' 
                id={isLanding ? "apartment-types-grid-landing" : "apartment-types-grid"} 
                justify="flex-start">
                    <div className='no-results-container'>
                        {message}
                    </div>                
            </div>
        </div>
    );
};

export default FeaturedSpaces;

FeaturedSpaces.propTypes = {    
    title: PropTypes.string,
    isHome: PropTypes.bool,    
    selectedCity: PropTypes.object,    
    errorMessage: PropTypes.string,
};
